import React, { useState } from "react";
import TitlePage from "../../components/section/TitlePage/Titlepage";
import { HiMagnifyingGlass } from "react-icons/hi2";
import { HospitalTable } from "./Hospital/hospital-table";
import { Dropdown } from "../../components/ui/Dropdown/Dropdown";
import { useNavigate } from "react-router-dom";

const searchByOptions = [
  {
    id: "email",
    name: "아이디(이메일주소)",
  },
  {
    id: "name",
    name: "병원명",
  },
  {
    id: "address",
    name: "주소",
  },
  {
    id: "contact",
    name: "전화번호",
  },
];

const hospitalOptions = [
  { id: "CREATED_AT_DESC", name: "최신순" },
  { id: "ORDERED_AT_DESC", name: "가입일자순" },
  { id: "ORDERED_AT_ASC", name: "마지막 주문일시순" },
  { id: "EMPLOYEE_AMOUNT_DESC", name: "소속 직원수순" },
  { id: "PATIENT_AMOUNT_DESC", name: "등록 환자수순" },
  { id: "WITHDRAWAL", name: "탈퇴회원순" },
];

const HospitalPage = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState({ orderBy: "CREATED_AT_DESC" });
  const [keyword, setKeyword] = useState("");
  const [searchBy, setSearchBy] = useState("email");

  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onChangeKeyword = (e) => {
    setKeyword(e.target.value);
  };

  const handleSearchByKeyword = (e) => {
    e.preventDefault();
    const { orderBy } = filter;
    setFilter({
      orderBy,
      [searchBy]: keyword,
    });
  };

  const onResetFilter = () => {
    setKeyword("");
    setFilter({
      orderBy: "CREATED_AT_DESC",
    });
  };

  return (
    <div>
      <TitlePage title="회원조회" />
      <div className="mt-5">
        <div className="flex justify-between h-9 mb-[15px]">
          <div className="flex gap-[14px]">
            <div className="flex">
              <div
                className={`cursor-pointer w-[150px] flex justify-center items-center bg-primary-blue text-white p-[5px]`}
              >
                병원회원
              </div>
              <div
                onClick={() => navigate("/patient")}
                className={`cursor-pointer w-[150px] flex justify-center items-center text-[#999999] border border-[#dddddd] p-[5px]`}
              >
                환자회원
              </div>
            </div>
            <div className="flex w-[27rem] gap-2">
              <Dropdown
                textColor="text-black"
                height="h-9"
                width="w-44"
                positionDropdown={`top-11`}
                placeholder="아이디(이메일주소)"
                options={searchByOptions}
                onClickItem={(id) => onChangeSearchBy(id)}
              />
              <form onSubmit={handleSearchByKeyword} className="flex">
                <div className="relative">
                  <input
                    type="text"
                    className="w-[220px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0"
                    placeholder="검색어 입력"
                    onChange={onChangeKeyword}
                    value={keyword}
                  />
                  <div
                    onClick={onResetFilter}
                    className={`text-[#3E6AB1] font-bold cursor-pointer absolute top-1/2 right-2 transform -translate-x-1/2 -translate-y-1/2 ${
                      keyword?.length ? "block" : "hidden"
                    }`}
                  >
                    X
                  </div>
                </div>
                <button
                  type="submit"
                  className="cursor-pointer bg-[#19459f] p-2 border-r border-[#19459f] rounded-r-[4px]"
                >
                  <HiMagnifyingGlass
                    onClick={handleSearchByKeyword}
                    className="text-white text-[18px] m-auto"
                  />
                </button>
              </form>
            </div>
          </div>
          <div>
            <Dropdown
              height="h-9"
              width="w-32"
              placeholder="최신순"
              options={hospitalOptions}
              positionDropdown={"top-11"}
              onClickItem={(id) => setFilter({ ...filter, orderBy: id })}
            />
          </div>
        </div>
        <HospitalTable filter={filter} />
      </div>
    </div>
  );
};

export default HospitalPage;
